export default "__VITE_ASSET__CVTmP5fd__"